// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutSidebarView_root__0ByIk","lineItemsList":"CheckoutSidebarView_lineItemsList__CHAk4"};